import { t } from "i18next";

function NotFoundPage() {

  return (
    <div 
      className="position-absolute text-white text-uppercase"
      style={{
        top:"50%",
        left:"50%",
        transform: "translatex(-50%)"
      }} 
    >
      {t('title.page_not_found')} 😢
    </div>
  );
}

export default NotFoundPage;